import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { useNavigate } from 'react-router-dom';

export default function Dashboard() {
  const [servicios, setServicios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [proyecto, setProyecto] = useState('exploradoras');
  const [filtroLote, setFiltroLote] = useState('');
  const [sincronizando, setSincronizando] = useState(false);
  const [ultimaSync, setUltimaSync] = useState(null);
  const [fechaSeleccionada, setFechaSeleccionada] = useState(new Date());
  const [resumenSiges, setResumenSiges] = useState({});
  const navigate = useNavigate();

  const confirmarServicio = async (servicioId, confirmado) => {
    const fecha = fechaSeleccionada.toISOString().split('T')[0];
    if (confirmado) {
      await api.delete(`/siges/confirmar-servicio/${servicioId}?fecha=${fecha}`);
    } else {
      await api.post(`/siges/confirmar-servicio/${servicioId}?fecha=${fecha}`);
    }
    cargar(fechaSeleccionada);
  };
  const [expandidos, setExpandidos] = useState(new Set());
  const [datosSiges, setDatosSiges] = useState({});

  const cargarDesglose = async (servicio) => {
    if (expandidos.has(servicio.id)) {
      setExpandidos(prev => { const s = new Set(prev); s.delete(servicio.id); return s; });
      return;
    }
    setExpandidos(prev => new Set(prev).add(servicio.id));
    
    // Cargar datos SIGES de cada tren del servicio
    const hoy = new Date().toISOString().split('T')[0];
    const datos = {};
    for (const tren of servicio.trenes) {
      try {
        const r = await api.get(`/siges/registros/${tren.numero_tren}?fecha=${hoy}`);
        datos[tren.numero_tren] = r.data;
      } catch {}
    }
    setDatosSiges(prev => ({ ...prev, [servicio.id]: datos }));
  };

  const sincronizar = async () => {
    setSincronizando(true);
    try {
      await api.post('/siges/sincronizar');
      setUltimaSync(new Date().toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' }));
      cargar();
    } catch (e) {
      alert('Error al sincronizar con SIGES — verifica que el proxy está activo');
    } finally {
      setSincronizando(false);
    }
  };

  const cargar = (fecha) => {
    const f = fecha || fechaSeleccionada;
    const fechaStr = f.toISOString().split('T')[0];
    api.get('/servicios-predefinidos/')
      .then(r => setServicios(r.data.filter(s => s.activo)))
      .finally(() => setLoading(false));
    api.get(`/siges/resumen-hoy?fecha=${fechaStr}`)
      .then(r => {
        const mapa = {};
        r.data.forEach(s => { mapa[s.servicio_id] = s; });
        setResumenSiges(mapa);
      })
      .catch(() => {});
  };

  const cambiarFecha = (dias) => {
    const nueva = new Date(fechaSeleccionada);
    nueva.setDate(nueva.getDate() + dias);
    setFechaSeleccionada(nueva);
    cargar(nueva);
  };

  useEffect(() => {
    cargar();
  }, []);

  const limpiarEstacion = (nombre) => {
    if (!nombre) return '';
    // Quitar codigo delante: "03300-POZORRUBIELOS" -> "POZORRUBIELOS"
    const partes = nombre.split('-');
    if (partes.length > 1 && /^[A-Z0-9]+$/.test(partes[0].trim())) {
      return partes.slice(1).join('-').trim();
    }
    return nombre;
  };

  const hoy = fechaSeleccionada;
  const diaSemana = hoy.getDay() === 0 ? '7' : String(hoy.getDay());


  const estadoConfig = {
    ok:        { bg: '#eaf3de', border: '#97c459', color: '#3b6d11', label: 'OK', icon: '✅' },
    amarillo:  { bg: '#faeeda', border: '#ef9f27', color: '#854f0b', label: 'Retraso', icon: '⚠️' },
    rojo:      { bg: '#fcebeb', border: '#e24b4a', color: '#a32d2d', label: 'Incidencia', icon: '🔴' },
    circulando: { bg: '#e8f0fe', border: '#4285f4', color: '#1a56db', label: 'En circulación', icon: '🔵' },
    sin_datos: { bg: '#f0f0f0', border: '#ddd',    color: '#888',    label: 'Sin datos', icon: '—' },
    sin_parte: { bg: '#f0f0f0', border: '#ddd',    color: '#888',    label: 'Sin datos', icon: '—' },
    ayer_ok:   { bg: '#f0f0f0', border: '#ddd',    color: '#888',    label: 'Sin datos', icon: '—' },
  };

  const filtrados = servicios.filter(s => {
    if (filtroLote && s.lote !== filtroLote) return false;
    return true;
  });

  const filtradosPorProyecto = filtrados.filter(s => (s.proyecto || 'exploradoras') === proyecto);
  const activos = filtradosPorProyecto.filter(s => s.dias_semana?.includes(diaSemana));
  const inactivos = filtradosPorProyecto.filter(s => !s.dias_semana?.includes(diaSemana));

  if (loading) return <div style={{ padding: 40, color: '#888' }}>Cargando...</div>;

  const renderTarjeta = (s) => {
    const sigesData = resumenSiges[s.id];
    const est = estadoConfig[sigesData?.estado || s.estado] || estadoConfig.sin_datos;
    const primerTren = s.trenes?.[0];
    const ultimoTren = s.trenes?.[s.trenes.length - 1];

    return (
      <div key={s.id} onClick={() => cargarDesglose(s)} style={{ cursor: 'pointer',
        background: '#fff', borderRadius: 12, position: 'relative',
        border: `1px solid ${est.border}`,
        padding: 16, display: 'flex', flexDirection: 'column', gap: 10
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>

          <div>
            <div style={{ fontWeight: 600, fontSize: 15 }}>{s.codigo}</div>
            <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>{s.lote}</div>
          </div>
          <span style={{
            background: est.bg, color: est.color, borderRadius: 20,
            padding: '4px 10px', fontSize: 12, fontWeight: 500
          }}>
            {est.icon} {est.label}
          </span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
          <span style={{ fontSize: 18 }}>🚂</span>
          <span style={{ fontWeight: 500 }}>
            {resumenSiges[s.id]?.locomotora_real || s.locomotora_numero || '—'}
          </span>
          {resumenSiges[s.id]?.locomotora_real && s.locomotora_numero && 
           resumenSiges[s.id].locomotora_real !== s.locomotora_numero && (
            <span style={{ fontSize: 10, background: '#faeeda', color: '#854f0b', borderRadius: 10, padding: '1px 6px' }}>
              asig: {s.locomotora_numero}
            </span>
          )}
        </div>

        {s.trenes?.length > 0 && (
          <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: 8, display: 'flex', flexDirection: 'column', gap: 4 }}>
            {(resumenSiges[s.id]?.trenes || s.trenes).map((t, i) => (
              <div key={i} style={{ fontSize: 12, color: '#444', display: 'flex', alignItems: 'center', gap: 6 }}>
                <span style={{ 
                  color: !t.tiene_datos ? '#bbb' :
                    !t.retraso_inicio || parseInt(t.retraso_inicio) <= 0 ? '#16a34a' :
                    parseInt(t.retraso_inicio) <= 30 ? '#854f0b' : '#a32d2d',
                  minWidth: 36, fontWeight: t.tiene_datos ? 600 : 400 
                }}>
                  {t.hora_inicio?.substring(0,5) || s.trenes[i]?.hora_inicio?.substring(0,5)}
                </span>
                <span style={{ fontWeight: 500, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {limpiarEstacion(t.estacion_inicio || s.trenes[i]?.estacion_inicio)}
                </span>
                <span style={{ color: '#aaa', margin: '0 2px' }}>→</span>
                <span style={{ 
                  color: !t.tiene_datos ? '#bbb' :
                    !t.retraso_fin || parseInt(t.retraso_fin) <= 0 ? '#16a34a' :
                    parseInt(t.retraso_fin) <= 30 ? '#854f0b' : '#a32d2d',
                  minWidth: 36, textAlign: 'right', fontWeight: t.tiene_datos ? 600 : 400 
                }}>
                  {t.en_ruta ? (t.hora_fin || '→') : (t.hora_fin || s.trenes[i]?.hora_fin?.substring(0,5) || '—')}
                </span>
                <span style={{ fontWeight: 500, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {t.en_ruta && t.ultima_estacion ? <span style={{fontStyle:'italic', color:'#4285f4'}}>{'En ruta · ' + limpiarEstacion(t.ultima_estacion)}</span> : limpiarEstacion(t.estacion_fin || s.trenes[i]?.estacion_fin)}
                </span>
              </div>
            ))}
          </div>
        )}

        {expandidos.has(s.id) && datosSiges[s.id] && (
          <div style={{ borderTop: '1px solid #f0f0f0', marginTop: 8, paddingTop: 8 }}>
            {s.trenes.map(t => {
              const paradas = datosSiges[s.id][t.numero_tren] || [];
              return (
                <div key={t.id} style={{ marginBottom: 8 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 4 }}>
                    Tren {t.numero_tren} — {t.estacion_inicio} → {t.estacion_fin}
                  </div>
                  {paradas.length > 0 ? (
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 11 }}>
                      <thead>
                        <tr style={{ background: '#f8f8f6' }}>
                          <th style={{ padding: '4px 8px', textAlign: 'left', color: '#888', fontWeight: 500 }}>Estación</th>
                          <th style={{ padding: '4px 8px', textAlign: 'center', color: '#888', fontWeight: 500 }}>Teo.</th>
                          <th style={{ padding: '4px 8px', textAlign: 'center', color: '#888', fontWeight: 500 }}>Real</th>
                          <th style={{ padding: '4px 8px', textAlign: 'center', color: '#888', fontWeight: 500 }}>Retraso</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paradas.map((p, i) => {
                          const haPasado = !!p.tipo;
                          const retraso = parseInt(p.retraso_salida || p.retraso_llegada || '0');
                          const colorR = retraso < -2 ? '#16a34a' : retraso <= 2 ? '#555' : retraso <= 10 ? '#854f0b' : '#a32d2d';
                          const labelR = retraso < 0 ? `${Math.abs(retraso)}m antes` : retraso === 0 ? 'Puntual' : `+${retraso}m`;
                          const hora = (h) => h ? h.replace('.0','').padStart(4,'0').replace(/(\d{2})(\d{2})/, '$1:$2') : '—';
                          return (
                            <tr key={i} style={{ borderTop: '1px solid #f5f5f5', opacity: haPasado ? 1 : 0.4 }}>
                              <td style={{ padding: '4px 8px' }}>{p.estacion}</td>
                              <td style={{ padding: '4px 8px', textAlign: 'center', color: '#aaa' }}>{hora(p.salida_teo || p.llegada_teo)}</td>
                              <td style={{ padding: '4px 8px', textAlign: 'center', fontWeight: 500 }}>
                                {haPasado ? hora(p.salida_real || p.llegada_real) : '—'}
                              </td>
                              <td style={{ padding: '4px 8px', textAlign: 'center', color: colorR, fontWeight: 500 }}>
                                {haPasado ? labelR : ''}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  ) : (
                    <div style={{ fontSize: 11, color: '#aaa', padding: '4px 8px' }}>Sin datos SIGES para hoy</div>
                  )}
                </div>
              );
            })}
          </div>
        )}
        <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: 8, marginTop: 4 }}>
          <button onClick={e => { e.stopPropagation(); navigate(`/staff/servicio/${s.id}`); }}
            style={{ padding: '4px 12px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 11, color: '#555', width: '100%' }}>
            Ver servicio →
          </button>
        </div>
        {s.ultimo_parte && (
          <div style={{ fontSize: 11, color: '#888' }}>
            Último parte: {new Date(s.ultimo_parte.fecha).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })}
            {s.ultimo_parte.km && ` · ${Math.round(s.ultimo_parte.km)} km`}
          </div>
        )}
        {expandidos.has(s.id) && (
          <div style={{ padding: '8px 16px', borderTop: '1px solid #f0f0f0', display: 'flex', justifyContent: 'flex-end' }}>
            {sigesData?.confirmado ? (
              <button onClick={e => { e.stopPropagation(); confirmarServicio(s.id, true); }} style={{
                padding: '5px 12px', borderRadius: 6, border: '1px solid #97c459',
                background: '#eaf3de', color: '#3b6d11', cursor: 'pointer', fontSize: 11, fontWeight: 500
              }}>✅ Confirmado — Deshacer</button>
            ) : (
              <button onClick={e => { e.stopPropagation(); confirmarServicio(s.id, false); }} style={{
                padding: '5px 12px', borderRadius: 6, border: '1px solid #ddd',
                background: '#fff', color: '#555', cursor: 'pointer', fontSize: 11
              }}>✓ Marcar como OK</button>
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
          <button onClick={() => cambiarFecha(-1)}
            style={{ width: 32, height: 32, borderRadius: '50%', border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            ‹
          </button>
          <div style={{ position: 'relative' }}>
            <h2 style={{ fontSize: 22, fontWeight: 500, margin: 0, textTransform: 'capitalize', cursor: 'pointer' }}
              onClick={() => document.getElementById('fecha-picker').showPicker()}>
              {fechaSeleccionada.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' })}
            </h2>
            <input id="fecha-picker" type="date"
              value={fechaSeleccionada.toISOString().split('T')[0]}
              max={new Date().toISOString().split('T')[0]}
              onChange={e => { const f = new Date(e.target.value + 'T12:00:00'); setFechaSeleccionada(f); cargar(f); }}
              style={{ position: 'absolute', opacity: 0, width: 0, height: 0, top: 0, left: 0 }} />
          </div>
          <button onClick={() => cambiarFecha(1)}
            style={{ width: 32, height: 32, borderRadius: '50%', border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: fechaSeleccionada.toDateString() === new Date().toDateString() ? 0.3 : 1 }}
            disabled={fechaSeleccionada.toDateString() === new Date().toDateString()}>
            ›
          </button>
        </div>
        <h2 style={{ fontSize: 22, fontWeight: 500, margin: 0, textTransform: 'capitalize', display: 'none' }}>{fechaSeleccionada.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' })}</h2>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 8 }}>
          <button onClick={sincronizar} disabled={sincronizando}
            style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: sincronizando ? '#888' : '#1a1a1a', color: '#fff', cursor: sincronizando ? 'not-allowed' : 'pointer', fontSize: 13, fontWeight: 500 }}>
            {sincronizando ? '⏳ Sincronizando...' : '🔄 Actualizar SIGES'}
          </button>
          {ultimaSync && <span style={{ fontSize: 12, color: '#888' }}>Última actualización: {ultimaSync}</span>}
        </div>
        <p style={{ fontSize: 13, color: '#888', marginTop: 4 }}>
          {activos.filter(s => s.estado === 'ok').length} de {activos.length} servicios con parte hoy
        </p>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        {[['exploradoras', '🚂 Exploradoras'], ['carrileros', '🔧 UTE Carrileros']].map(([val, label]) => (
          <button key={val} onClick={() => { setProyecto(val); setFiltroLote(''); }} style={{
            padding: '8px 18px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 600,
            background: proyecto === val ? '#1a1a1a' : '#e5e5e5',
            color: proyecto === val ? '#fff' : '#555'
          }}>{label}</button>
        ))}
      </div>
      {proyecto === 'exploradoras' && (
        <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
          {[['', 'Todos'], ['lote1', 'Lote 1'], ['lote2', 'Lote 2']].map(([val, label]) => (
            <button key={val} onClick={() => setFiltroLote(val)} style={{
              padding: '7px 16px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 500,
              background: filtroLote === val ? '#1a1a1a' : '#f0f0f0',
              color: filtroLote === val ? '#fff' : '#555'
            }}>{label}</button>
          ))}
        </div>
      )}

      {activos.length > 0 && (
        <>
          <div style={{ fontSize: 13, fontWeight: 500, color: '#555', marginBottom: 10 }}>
            Servicios de hoy ({activos.length})
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 12, marginBottom: 24 }}>
            {activos.map(renderTarjeta)}
          </div>
        </>
      )}

      {inactivos.length > 0 && (
        <>
          <div style={{ fontSize: 13, fontWeight: 500, color: '#aaa', marginBottom: 10 }}>
            No operativos hoy ({inactivos.length})
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 12, opacity: 0.5 }}>
            {inactivos.map(renderTarjeta)}
          </div>
        </>
      )}
    </div>
  );
}
